

  var font_family = 'Poppins';
  var font_family_title = 'Montserrat';

  
    font_family = "Montserrat";
  

  
    font_family_title = "https://fonts.googleapis.com/css2";
  

  WebFontConfig = {
    google: { families: [
      font_family + ":400,400i,500,500i,700,700i",
      font_family_title + ":400,400i,500,500i,700,700i",
    ] },
    active: function() {
      if (window.slate) {
        window.slate.header.menuArrange();
      }
    },
  };
  (function() {
    var wf = document.createElement('script');
    wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
      '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
  })();


